import { render, staticRenderFns } from "./ApplicationsWidget.vue?vue&type=template&id=f061ab24&"
import script from "./ApplicationsWidget.vue?vue&type=script&lang=js&"
export * from "./ApplicationsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports